import { FirestoreInstance } from '@griply/services';
import { doc as _doc } from 'firebase/firestore';

export const doc = _doc as unknown as (
  firestore: FirestoreInstance,
  path: string,
  id: string,
) => ReturnType<typeof _doc>;
